import React from 'react';
import {useLingui} from "@lingui/react";

function FormattedDate({
    value, month, day, year,
    hour, hour12, minute, second
                       }:{
    value: string,
    hour?: "numeric",
    hour12?: boolean,
    minute?: "numeric",
    second?: "numeric",
    month?: "short" | "long",
    day?: "numeric",
    year?: "numeric"
}) {
    const { _, i18n } = useLingui();

    return <span>{i18n.date(new Date(value), {year, month, day, hour, hour12, minute, second})}</span>
}

export default FormattedDate;